export default __webpack_public_path__ + "static/google-reviews-dd5e66a87ec5a6b53199c4cf9071bbea.svg";